export default {
  template: '#portfolio_widget_template',
};